import { ModelBase } from '@singularsystems/neo-core';
import { Catalogue } from '@singularsystems/neo-react-services';
import { IGenericApiClient } from '../../ApiClients/Catalogues/GenericApiClient';
import DataCache from '../../Services/DataCache';

/** Generic catalogue component base. */
export abstract class CatalogueEntry<TModel extends ModelBase> extends Catalogue.CatalogueEntryBase<TModel, DataCache, IGenericApiClient> {

}